// Due to "npx vercel env pull .env.local" on "predev" we can't really use .env for this
// Comment all but the one you want out

export default [
  "https://login2.sesamy.dev",
  // "https://local.sesamy.dev:3000",
  // "https://host.docker.internal:3000",
][0];
